/* eslint-disable no-restricted-imports */
import styled from 'styled-components';

import { ParagraphMd } from '@olist/design-system';

export const SubTitle = styled(ParagraphMd)`
  color: ${(props) => props.theme.olist.color.neutral.base};
  font-weight: 400;
`;

export const PresentationImage = styled.img`
  border-radius: 12px;
  height: 100%;
  max-width: 658px;
  min-height: calc(100vh - 154px);
  object-fit: none;
  width: 100%;

  @media screen and (max-width: 671px) {
    min-height: 308px;
    max-width: unset;
    margin-bottom: 32px;
    object-fit: cover;
  }
`;

export const PresentationList = styled.ul`
  margin: 32px 0;

  li {
    display: flex;
    svg {
      color: ${(props) => props.theme.olist.color.primary.base};
      margin-right: 10px;
    }
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export const ImageContainer = styled.div`
  #presentation-img-m {
    display: none;
  }

  @media screen and (max-width: 671px) {
    #presentation-img-w {
      display: none;
    }

    #presentation-img-m {
      display: block;
    }
  }
`;
